import { Card } from 'antd';
import './style.scss';
import './mobile.scss';

type HeaderCardProps = {
  headerLabel: React.ReactNode;
  headerInfo: React.ReactNode;
  filters?: React.ReactNode;
};

const HeaderCard = ({ headerLabel, headerInfo, filters }: HeaderCardProps) => {
  return (
    <Card className="header-card">
      <div className="header-container">
        <div className="label-container">
          <div className="header-label semibold">{headerLabel}</div>
          <div className="header-info">{headerInfo}</div>
        </div>
        {filters ? <div className="filter-container">{filters}</div> : null}
      </div>
    </Card>
  );
};

export default HeaderCard;
